// `adminCard` es el radio de card del panel administrativo (adición).
// 10px, coincidiendo con `adminLayout.cardRadius` (ver
// theme/foundations/adminPanel.js) tras la compactación de la escala.
const radii = { sm: '8px', md: '10px', lg: '14px', adminCard: '10px' };

export default radii;
